import Controls from "../components/Controls";
import RoomHeader from "../components/RoomHeader";
import { useTranslation } from "../components/Localization";
import { getGameScore } from "../services/gameScores";

export default function MirrorScorePage() {
  const { t } = useTranslation();
  const paintingScore = getGameScore("paintingOne") + getGameScore("paintingTwo");
  const ringsScore = getGameScore("rings");
  return (
    <main className="screen score mirror-score">
      <RoomHeader roomId="mirror" />
      <div className="score-copy">
        <strong className="mirror-score-title">{t("common.completed")}</strong>
        <div className="mirror-score-progress" aria-label="7/7">
          <div className="mirror-score-dots" aria-hidden="true">
            {Array.from({ length: 7 }, (_, index) => <i key={index} />)}
          </div>
          <span>7/7</span>
        </div>
        <div className="mirror-score-results room-score-results">
          <p>{t("score.paintingResult", { score: paintingScore, max: 20 })}</p>
          <p>{t("score.ringsResult", { score: ringsScore, max: 15 })}</p>
        </div>
        <p className="mirror-score-message">
          {t("score.secondRoom")}
          <br />
          {t("score.continue")}
        </p>
      </div>
      <Controls backTo="/tukorterem/gyuruk" nextTo="/szalon" />
    </main>
  );
}
